import { STATUS_META } from "@/lib/constants";
import { useLang } from "@/i18n/LanguageContext";

export function StatusBadge({ status, className = "" }) {
  const meta = STATUS_META[status] || STATUS_META.pending;
  const { t } = useLang();
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-2 rounded-full border ${meta.ring} bg-white/[0.03] px-3 py-1 text-xs font-medium ${meta.color} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
      {t(`status.${status}`)}
    </span>
  );
}
